var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabbed-page-layout',{staticClass:"boxes",attrs:{"title":"Emballage","pages":_vm.pages}})
}
var staticRenderFns = []

export { render, staticRenderFns }